export default __webpack_public_path__ + "static/media/5.c9fc16b4.png";